import React from 'react';
import { FiCode, FiSmartphone, FiCpu } from 'react-icons/fi';
import {
  Section,
  SectionInner,
  SectionHeader,
  Eyebrow,
  SectionTitle,
  SectionLead,
} from '../ui/Section';
import {
  ServicesGrid,
  ServiceCard,
  ServiceIcon,
  ServiceTitle,
  ServiceText,
} from './ServicesElements';

const SERVICES = [
  {
    icon: <FiCode />,
    title: 'Web & Software Development',
    text:
      'Custom web applications and backend systems, built to scale and thoroughly tested before they ship.',
  },
  {
    icon: <FiSmartphone />,
    title: 'Mobile App Development',
    text:
      'From complex social platforms to focused business tools, we design and build mobile apps end to end.',
  },
  {
    icon: <FiCpu />,
    title: 'AI & Product Engineering',
    text:
      'We turn ideas into products — including AI-powered tools like Repatch — and maintain and upgrade existing systems.',
  },
];

const Services = () => {
  return (
    <Section id='services'>
      <SectionInner>
        <SectionHeader>
          <Eyebrow>Services</Eyebrow>
          <SectionTitle>Consulting that ships</SectionTitle>
          <SectionLead>
            Cloutch LLC partners with companies to design and build reliable
            software. Engagements range from a single sprint to long-term product
            development.
          </SectionLead>
        </SectionHeader>
        <ServicesGrid>
          {SERVICES.map((s) => (
            <ServiceCard key={s.title}>
              <ServiceIcon>{s.icon}</ServiceIcon>
              <ServiceTitle>{s.title}</ServiceTitle>
              <ServiceText>{s.text}</ServiceText>
            </ServiceCard>
          ))}
        </ServicesGrid>
      </SectionInner>
    </Section>
  );
};

export default Services;
